import { render, staticRenderFns } from "./AppPager.vue?vue&type=template&id=030d8c7b&scoped=true"
import script from "./AppPager.vue?vue&type=script&lang=js"
export * from "./AppPager.vue?vue&type=script&lang=js"
import style0 from "./AppPager.vue?vue&type=style&index=0&id=030d8c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d8c7b",
  null
  
)

export default component.exports